import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ENV } from './environments/environment';

import { environmentLoader as environmentLoaderPromise } from './environments/environmentLoader';

environmentLoaderPromise.then(env => {
  if (ENV.production) {
    enableProdMode();    
  }
  ENV.settings = env.settings;

  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
});
